<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{
        customTitle ||
          ((isSelectionMode ? "ORDER_PRODUCTS.UPSALE_TITLE" : "ORDER_PRODUCTS.TITLE")
            | translate)
      }}
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <div
        class="gt2-light-green flex-row-center-center"
        style="width: 60px; height: 56px"
      >
        <button
          type="button"
          matTooltip="{{ 'ORDER_PRODUCTS.CREATE_PRODUCT' | translate }}"
          mat-icon-button
          (click)="onCreateProduct()"
        >
          <mat-icon class="icon-mat-black">add</mat-icon>
        </button>
      </div>
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div class="flex-column">
      <!-- Mode selection (groupe d'options upsale) : nom du groupe + choix obligatoire -->
      @if (groupMeta) {
        <div class="flex-row-start-center" style="gap: 16px; flex-wrap: wrap">
          <mat-form-field floatLabel="auto" style="min-width: 280px">
            <mat-label>{{ "ORDER_PRODUCTS.GROUP_NAME" | translate }}</mat-label>
            <input matInput [(ngModel)]="groupName" required />
          </mat-form-field>
          @if (showChoiceRequiredCheckbox) {
            <mat-checkbox color="primary" [(ngModel)]="groupChoiceRequired">
              {{ "ORDER_PRODUCTS.CHOICE_REQUIRED_NO_SKIP" | translate }}
            </mat-checkbox>
          }
        </div>
      }

      <mat-form-field floatLabel="auto" class="mr-4 fxFlexAuto">
        <mat-label>{{
          "ORDER_PRODUCTS.SEARCH" | translate | ucfirst
        }}</mat-label>
        <input #filter id="search" [(ngModel)]="filterValue" matInput />
        <mat-icon
          mat-icon
          aria-label="Search"
          *ngIf="filterValue"
          matSuffix
          (click)="loadProductList()"
          >search</mat-icon
        >
        <button
          mat-button
          *ngIf="filterValue"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- Filtres additionnels : catégorie de produit + tags. Utilisables avec
           ou sans mot-clé (un filtre actif suffit à lancer la recherche). -->
      <div class="product-filters-row flex-row-start-center">
        <p-dropdown
          [options]="productCategories"
          [(ngModel)]="selectedCategoryUuid"
          (onChange)="onProductFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          [filter]="true"
          placeholder="{{ 'ORDER_PRODUCTS.CATEGORY_FILTER' | translate }}"
          [style]="{ minWidth: '220px' }"
        ></p-dropdown>
        <p-multiSelect
          *ngIf="availableTags.length > 0"
          [options]="availableTags"
          [(ngModel)]="selectedTagUuids"
          (onChange)="onProductFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          placeholder="{{ 'ORDER_PRODUCTS.TAGS_FILTER' | translate }}"
          selectedItemsLabel="{0} tags"
          [style]="{ minWidth: '180px' }"
        >
          <ng-template let-tag pTemplate="item">
            <div class="flex-row-start-center" style="gap: 8px">
              <span class="tag-color-dot" [ngClass]="tag.color"></span>
              {{ tag.name }}
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      @if (!isSmallScreen) {
        <div class="flex-row fxLayout-column-xs" style="margin-bottom: 16px">
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_PRODUCTS.LEFT_LIST_LABEL" | translate }}
            </div>
          </div>
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_PRODUCTS.RIGHT_LIST_LABEL" | translate }}
            </div>
          </div>
        </div>
      }

      <div cdkDropListGroup class="flex-row fxLayout-column-xs">
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_PRODUCTS.LEFT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #productList
            cdkDropList
            [cdkDropListData]="products"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
            ngxDroppable="example-target"
          >
            <div
              *ngIf="isLoading"
              class="flex-column-center-center fxFlex-100p"
            >
              <mat-spinner [diameter]="28" class=""></mat-spinner>
            </div>

            <div
              *ngIf="showSearchProductHint"
              class="flex-column-center-center fxFlex-100p combo-list-empty-message"
            >
              {{ "ORDER_PRODUCTS.SEARCH_PRODUCT" | translate }}
            </div>

            <div
              *ngIf="showNoSearchResults"
              class="flex-column-center-center fxFlex-100p combo-list-empty-message combo-no-results-lines"
            >
              <div>{{ "ORDER_PRODUCTS.NO_SEARCH_RESULTS_LINE1" | translate }}</div>
              <div>{{ "ORDER_PRODUCTS.NO_SEARCH_RESULTS_LINE2" | translate }}</div>
            </div>

            <!-- <div *ngIf="!isLoading"> -->
            @for (product of products; track product; let i = $index) {
              <div
                *ngIf="!isLoading"
                cdkDragHandle
                matRipple
                [cdkDragData]="product"
                cdkDrag
                [cdkDragDisabled]="mobileLayout.isMobileLayout()"
              >
                <div class="product-child-item flex-row-space-between-center">
                  <div class="flex-row-start-center">
                    <mat-icon
                      *ngIf="!mobileLayout.isMobileLayout()"
                      class="mr-8"
                      >drag_handle</mat-icon
                    >
                    <!--                                <div matTooltip="{{item.name + ' | ' + item.price_label}}" [matTooltipPosition]="'right'">{{item.name_internal}}</div>-->
                    <div style="min-width: 200px">
                      <div class="item-name-internal">
                        {{ product.name_internal }}
                      </div>
                      <div class="item-name">
                        {{
                          product.name +
                            " | " +
                            product.price_label +
                            (product.is_combo && product.is_choice_product_combo ? " | Combo dynamique" : product.is_combo ? " | Combo" : "")
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="flex-row-end-center fxFlex-60">
                    <mat-icon
                      mat-icon
                      class="ml-8"
                      (click)="onAddItem(product, true)"
                      >add</mat-icon
                    >

                    <mat-icon
                      matTooltip="{{ 'GENERIC.OPEN_NEW_TAB' | translate }}"
                      (click)="onOpenInNewTab(product)"
                      mat-icon
                      class="ml-8 mr-8"
                      >{{ getIcon("NEW_TAB") }}</mat-icon
                    >
                  </div>
                </div>
              </div>
            }
            <!-- </div> -->
          </div>
        </div>
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_PRODUCTS.RIGHT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #comboList
            cdkDropList
            [cdkDropListData]="combo"
            (cdkDropListDropped)="onDrop($event)"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
            ngxDroppable="example-target"
          >
            @for (comb of combo; track comb; let i = $index) {
              <div
                matRipple
                [cdkDragData]="comb"
                cdkDrag
                [cdkDragDisabled]="mobileLayout.isMobileLayout()"
                ngxDraggable
              >
                <div
                  class="product-child-item-right"
                  [class.has-price-override]="isSelectionMode && showPriceOverride"
                >
                  <div class="right-row-main flex-row-space-between-center">
                    <div class="flex-row-start-center">
                      <mat-icon
                        *ngIf="!mobileLayout.isMobileLayout()"
                        cdkDragHandle
                        class="mr-8 qty-drag-handle"
                        >drag_handle</mat-icon
                      >
                      @if (!isSelectionMode) {
                        <mat-form-field class="form-input-container qty-input">
                          <input
                            matInput
                            class="text-center"
                            type="text"
                            pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
                            [ngModel]="comb.qty"
                            (ngModelChange)="onItemQtyChange($event, comb)"
                            style="text-align: center"
                          />
                        </mat-form-field>
                      }
                      <div
                        matTooltip="{{ comb.name }}"
                        [matTooltipPosition]="'right'"
                        class="ml-16 item-name-right"
                      >
                        {{ comb.name_internal }}
                      </div>
                    </div>

                    <div class="flex-row-end-center">
                      @if (!isSelectionMode) {
                        <mat-icon (click)="onAddItem(comb, true)" class="ml-8"
                          >add</mat-icon
                        >
                        <mat-icon (click)="onLessItem(comb, i)" class="ml-8"
                          >remove</mat-icon
                        >
                      }
                      <mat-icon (click)="onRemoveItem(comb, i)" class="ml-8"
                        >delete</mat-icon
                      >
                    </div>
                  </div>

                  @if (isSelectionMode && showPriceOverride) {
                    <div class="price-override flex-row-start-center">
                      <span class="original-price">
                        {{ "ORDER_PRODUCTS.ORIGINAL_PRICE" | translate }}:
                        {{ getOriginalPriceLabel(comb) }}
                      </span>
                      <mat-form-field
                        floatLabel="always"
                        class="form-input-container new-price-input"
                      >
                        <mat-label>{{
                          "ORDER_PRODUCTS.NEW_PRICE" | translate
                        }}</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          step="0.01"
                          [ngModel]="comb.override_price"
                          (ngModelChange)="onOverridePriceChange($event, comb)"
                          [placeholder]="getOriginalPriceLabel(comb)"
                        />
                        <span matSuffix>$</span>
                      </mat-form-field>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div
          [ngClass]="
            isSmallScreen ? 'flex-row fxFlex-100p' : 'flex-row fxFlex-50p'
          "
        >
          &nbsp;
        </div>

        <div
          [ngClass]="
            isSmallScreen
              ? 'flex-row-end-start fxFlex-100p'
              : 'flex-row-end-start fxFlex-50p'
          "
        >
          <div *ngIf="combo && combo.length > 0" class="pr-4">
            {{ combo.length }}
            {{ combo && combo.length > 1 ? "items" : "item" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button
      mat-raised-button
      (click)="onSaveProducts()"
      [disabled]="saveDisabled"
      class="accent mr-16"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="close()"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
